(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-premium"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initPremiumPDP(root){
    if(!root || root.getAttribute('data-mlx-ready') === 'true') return;
    root.setAttribute('data-mlx-ready', 'true');

    var variants = [];
    var variantsEl = root.querySelector('[data-variants]');
    try {
      variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    } catch(e) {
      variants = [];
    }

    var form        = root.querySelector('.mlx-form');
    var idInput     = root.querySelector('[data-variant-id]');
    var addBtn      = root.querySelector('[data-add]');
    var addText     = root.querySelector('[data-add-text]');
    var priceEl     = root.querySelector('[data-price]');
    var compareEl   = root.querySelector('[data-compare]');
    var finalPrice  = root.querySelector('[data-final-price]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var optionGroups = Array.prototype.slice.call(root.querySelectorAll('.mlx-chips[data-option-position]'));

    function currentSelection(){
      return optionGroups.map(function(group){
        var active = group.querySelector('.mlx-chip[aria-pressed="true"]');
        return active ? active.getAttribute('data-value') : null;
      });
    }

    function findVariant(){
      if(!variants.length) return null;

      if(!optionGroups.length){
        var currentId = idInput ? String(idInput.value) : '';
        return variants.find(function(v){ return String(v.id) === currentId; }) || variants[0];
      }

      var selected = currentSelection();
      if(selected.some(function(value){ return value === null; })) return null;

      return variants.find(function(v){
        return (v.options || []).every(function(value, index){
          return value === selected[index];
        });
      }) || null;
    }

    function updateVariantUI(){
      var variant = findVariant();

      if(!variant){
        if(addBtn) addBtn.disabled = true;
        if(addText) addText.textContent = 'Choose options';
        return;
      }

      if(idInput) idInput.value = variant.id;
      if(priceEl) priceEl.textContent = variant.price;
      if(finalPrice) finalPrice.textContent = variant.price;
      if(stickyPrice) stickyPrice.textContent = variant.price;

      if(compareEl){
        if(variant.has_compare){
          compareEl.textContent = variant.compare;
          compareEl.hidden = false;
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
      }

      if(addBtn){
        addBtn.disabled = !variant.available;
      }

      if(addText){
        addText.textContent = variant.available
          ? 'Add to bag — ' + variant.price
          : 'Sold out';
      }
    }

    optionGroups.forEach(function(group){
      group.addEventListener('click', function(event){
        var button = event.target.closest('.mlx-chip');
        if(!button || !group.contains(button)) return;

        group.querySelectorAll('.mlx-chip').forEach(function(chip){
          chip.setAttribute('aria-pressed', chip === button ? 'true' : 'false');
        });

        updateVariantUI();
      });
    });

    var stage = root.querySelector('[data-stage]');
    var navs = Array.prototype.slice.call(root.querySelectorAll('.mlx-thumb, .mlx-dot'));

    if(stage && navs.length){
      navs.forEach(function(nav){
        nav.addEventListener('click', function(){
          var index = parseInt(nav.getAttribute('data-go'), 10) || 0;
          var slide = stage.querySelector('[data-slide="' + index + '"]');
          if(slide){
            stage.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          }
        });
      });

      var galleryFrame = null;
      stage.addEventListener('scroll', function(){
        if(galleryFrame) cancelAnimationFrame(galleryFrame);
        galleryFrame = requestAnimationFrame(function(){
          var width = stage.clientWidth || 1;
          var index = Math.round(stage.scrollLeft / width);
          navs.forEach(function(nav){
            nav.classList.toggle(
              'is-active',
              parseInt(nav.getAttribute('data-go'), 10) === index
            );
          });
        });
      }, { passive: true });
    }

    root.querySelectorAll('[data-scroll-buy]').forEach(function(button){
      button.addEventListener('click', function(){
        var buy = root.querySelector('.mlx-buy');
        if(buy) buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    var modal = root.querySelector('[data-modal]');

    function showPanel(which){
      root.querySelectorAll('.mlx-panel').forEach(function(panel){
        panel.hidden = panel.getAttribute('data-panel') !== which;
      });
    }

    function openModal(which){
      if(!modal) return;
      showPanel(which);
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeModal(){
      if(!modal || modal.hidden) return;
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    root.querySelectorAll('[data-open]').forEach(function(button){
      button.addEventListener('click', function(){
        openModal(button.getAttribute('data-open'));
      });
    });

    if(modal){
      modal.querySelectorAll('[data-close]').forEach(function(button){
        button.addEventListener('click', closeModal);
      });

      document.addEventListener('keydown', function(event){
        if(event.key === 'Escape') closeModal();
      });
    }

    var mmInput = root.querySelector('[data-fit-mm]');
    var fitOut = root.querySelector('[data-fit-out]');
    var fitSizeEl = root.querySelector('[data-fit-size]');
    var fitApply = root.querySelector('[data-fit-apply]');
    var recommended = null;

    function recommendSize(){
      if(!mmInput) return;

      var value = parseFloat(mmInput.value);
      if(isNaN(value)){
        recommended = null;
        if(fitOut) fitOut.hidden = true;
        return;
      }

      if(value <= 11) recommended = 'XS';
      else if(value <= 12) recommended = 'S';
      else if(value <= 13) recommended = 'M';
      else recommended = 'L';

      if(fitSizeEl) fitSizeEl.textContent = recommended;
      if(fitOut) fitOut.hidden = false;
    }

    if(mmInput){
      mmInput.addEventListener('input', recommendSize);
    }

    if(fitApply){
      fitApply.addEventListener('click', function(){
        if(!recommended) return;

        var sizeChip = Array.prototype.find.call(
          root.querySelectorAll('.mlx-chip'),
          function(chip){
            return (chip.getAttribute('data-value') || '').toUpperCase() === recommended;
          }
        );

        if(sizeChip){
          sizeChip.click();
          closeModal();
        }
      });
    }

    var sticky = root.querySelector('[data-sticky]');
    var buyBox = root.querySelector('.mlx-buy');

    if(sticky && buyBox && 'IntersectionObserver' in window){
      var stickyObserver = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(window.innerWidth > 860){
            sticky.classList.remove('is-show');
            return;
          }

          sticky.classList.toggle(
            'is-show',
            !entry.isIntersecting && entry.boundingClientRect.top < 0
          );
        });
      }, { threshold: 0 });

      stickyObserver.observe(buyBox);
    }

    function openCartDrawer(){
      var drawer = document.querySelector('cart-drawer-component, cart-drawer');
      if(!drawer) return false;

      if(typeof drawer.open === 'function'){
        try {
          drawer.open();
          return true;
        } catch(e){}
      }

      return false;
    }

    if(form){
      form.addEventListener('submit', function(event){
        if(!window.fetch) return;

        event.preventDefault();
        if(addBtn && addBtn.disabled) return;

        var variant = findVariant();
        if(!variant || !variant.available){
          updateVariantUI();
          return;
        }

        var previousLabel = addText ? addText.textContent : '';

        if(addBtn) addBtn.disabled = true;
        if(addText) addText.textContent = 'Adding…';

        var formData = new FormData(form);
        var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
          ? window.Shopify.routes.root
          : '/';

        fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
        .then(function(response){
          if(!response.ok){
            return response.json()
              .catch(function(){ return {}; })
              .then(function(error){ throw error; });
          }
          return response.json();
        })
        .then(function(item){
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              source: 'mlx-pdp',
              data: {
                source: 'mlx-pdp',
                didError: false,
                variantId: String(item.variant_id || variant.id)
              }
            }
          }));

          if(addText) addText.textContent = 'Added ✓';

          if(!openCartDrawer()){
            window.location.assign(rootPath + 'cart');
          }
        })
        .catch(function(error){
          if(addText){
            addText.textContent = error && error.description
              ? error.description
              : 'Couldn’t add — try again';
          }
        })
        .finally(function(){
          window.setTimeout(function(){
            if(addBtn) addBtn.disabled = !variant.available;
            if(addText && addText.textContent === 'Added ✓'){
              addText.textContent = previousLabel;
            }
          }, 900);
        });
      });
    }

    updateVariantUI();
  }

  function initAllPremiumPDPs(scope){
    var context = scope || document;
    if(context.matches && context.matches('[data-mlx-pdp]')){
      initPremiumPDP(context);
    }
    if(context.querySelectorAll){
      context.querySelectorAll('[data-mlx-pdp]').forEach(initPremiumPDP);
    }
  }

  initAllPremiumPDPs(document);

  document.addEventListener('shopify:section:load', function(event){
    initAllPremiumPDPs(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
